import { type DatabaseChangeType } from '@databases/types/redux';

import { type YJSChangeHandler } from '../../types.ts';

export const setContentField: YJSChangeHandler<DatabaseChangeType.SET_CONTENT_FIELD> = ({
  ydb,
  change
}) => {
  ydb.mutate((db) => {
    const field = db.fieldsById[change.fieldId];

    field.contentField = change.contentField;
  });
};
